import {
    ApiClientFactory
} from '../ApiClientFactory';
import {
    API_V4_URL
} from '../Variables';

let clientFactory = new ApiClientFactory(API_V4_URL);

export const MentorClient = {

    getMentors() {
        return clientFactory.get(`/mentors`);
    },
};